export enum PrepaySubscriptionVariant {
  One = 'variant-one',
  Two = 'variant-two',
}
